import { useCallback, useEffect, useRef } from 'react';

export const RELOAD_AFTER_FAILURE_MS = 30000;

const useReloadAfterFailure = () => {
    const timerRef = useRef(null);

    const cancel = useCallback(() => {
        clearTimeout(timerRef.current);
        timerRef.current = null;
    }, []);

    useEffect(() => cancel, [cancel]);

    return useCallback((reload) => {
        cancel();
        timerRef.current = setTimeout(reload, RELOAD_AFTER_FAILURE_MS);
    }, [cancel]);
};

export default useReloadAfterFailure;
